import React from "react";
import GptSearchBar from "./GptSearchBar";
import GptMovieSuggestions from "./GptMovieSuggestions";
import { BG_URL } from "../../utils/constants";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import Header from "../layout/Header";

const GptSearch = () => {
  const movieNames = useSelector((store: RootState) => store.gpt.movieNames);

  return (
    <div className="relative min-h-screen bg-black overflow-x-hidden">
      <Header />

      {/* Cinematic Background Layer */}
      <div className="fixed inset-0 -z-10">
        <img
          className="h-full w-full object-cover brightness-[0.2] scale-105 transition-transform duration-[20s] ease-linear animate-pulse-slow"
          src={BG_URL}
          alt="background"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black via-[#0a0a0a]/80 to-black"></div>
        <div className="absolute inset-0 backdrop-blur-[4px]"></div>
      </div>

      <div className={`flex flex-col items-center px-4 w-full transition-all duration-1000 ease-in-out ${movieNames ? "pt-28" : "justify-center min-h-screen pt-20"
        }`}>
        <div className="w-full max-w-7xl mx-auto">
          <GptSearchBar />
          <GptMovieSuggestions />
        </div>
      </div>
    </div>
  );
};

export default GptSearch;
